/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
window.M = require('materialize-css/dist/js/materialize.min');
window.slider = require('lightslider/dist/js/lightslider.min');
window.Vue = require('vue');
window.Swal = require('sweetalert2')

import Vuelidate from 'vuelidate'
import moment from 'moment'

import VueCountdown from '@chenfengyuan/vue-countdown';



window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found');
}


M.AutoInit();


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('recipe-component', require('./components/RecipeComponent.vue').default);
Vue.component('product-component', require('./components/ProductComponent.vue').default);
Vue.component('warranty-view-component', require('./components/warranty/ViewComponent.vue').default);
Vue.component('warranty-search-component', require('./components/warranty/SearchComponent.vue').default);
Vue.component('instagram-component', require('./components/InstagramComponent.vue').default);

Vue.component('user-search-component', require('./components/user/SearchComponent.vue').default);

Vue.component('profile-component', require('./components/warranty/ProfileComponent.vue').default);

//redemption component
Vue.component('product-list-component', require('./components/redemption/ProductListComponent.vue').default);
Vue.component('product-single-component', require('./components/redemption/ProductComponent.vue').default);
Vue.component('dealer-component', require('./components/DealerComponent.vue').default);
Vue.component('rice-day-component', require('./components/redemption/RiceDayComponent.vue').default);
Vue.component('otp-component', require('./components/OtpComponent.vue').default);
Vue.component('cny-2022-component', require('./components/redemption/Cny2022Component.vue').default);
Vue.component('raya-2022-component', require('./components/redemption/Raya2022Component.vue').default)

Vue.component(VueCountdown.name, VueCountdown);

// Filters
Vue.filter("numberComma", function(value) {
    if (value) {
        let parts = value.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    } else {
        return value;
    }
});

var filter = function(text, length, clamp){
    clamp = clamp || '...';
    var node = document.createElement('div');
    node.innerHTML = text;
    var content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate', filter);

Vue.use(Vuelidate);

Vue.prototype.moment = moment


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
